import { Validator } from '@portal/kit/pkg/services'

const userFullNameValidator = values => {
  const rules = {
    'first_name': ['isRequired'],
    'last_name': ['isRequired']
  }

  return new Validator(values, rules).getErrors()
}

export default userFullNameValidator
